// eslint-disable-next-line import/prefer-default-export
export const print = () => {
    console.log('in helper');
    window.print();
}